import { FormikTextArea } from "@faire/deprecated-retailer-visitor-shared/components/Form/FormikTextArea";
import { CommonForm } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/CommonForm";
import {
  SignUpPill,
  SignUpPillContainer,
} from "@faire/deprecated-retailer-visitor-shared/views/SignUp/_components/SignUpPill";
import { SocialMediaData } from "@faire/deprecated-retailer-visitor-shared/views/SignUp/owf-grant-social-media/OwFGrantSocialMediaStep";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Button } from "@faire/web/slate/Button";
import { Flex } from "@faire/web/slate/Layout";
import { Spacer, getSpacing } from "@faire/web/slate/spacing";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import { useFormikContext } from "formik";
import isUndefined from "lodash/isUndefined";
import React, { FormEvent } from "react";
import styled from "styled-components";
import * as Yup from "yup";

export const OwFGrantSocialMediaForm: React.FC<{ loading: boolean }> = ({
  loading,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const { values, setFieldValue, handleSubmit, isValid } =
    useFormikContext<SocialMediaData>();

  const isNextEnabled = !isUndefined(values.has_social_media) && isValid;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  return (
    <CommonForm onSubmit={onSubmit} loading={loading}>
      <SocialMediaContainer>
        <SignUpPill
          key="true"
          title={strictLocalize({
            id: "tyfD6E",
            defaultMessage: "Yes",
            description: { text: "Answer for a yes or no question" },
          })}
          isSelected={!!values.has_social_media}
          onClick={() => setFieldValue("has_social_media", true)}
          dataTestId="PILL_SOCIAL_MEDIA_TRUE"
        />
        <SignUpPill
          key="false"
          title={strictLocalize({
            id: "D92P2q",
            defaultMessage: "Not yet",
            description: { text: "Answer for a yes or no question" },
          })}
          isSelected={values.has_social_media === false}
          onClick={() => setFieldValue("has_social_media", false)}
          dataTestId="PILL_SOCIAL_MEDIA_TRUE"
        />
      </SocialMediaContainer>
      {values.has_social_media ? (
        <>
          <Spacer height="5x" />
          <FormikTextArea
            rows={5}
            name="social_media"
            data-test-id="social_media"
            label={strictLocalize({
              id: "kW7tZY",
              defaultMessage: "Social media links",
              description: {
                text: "Ask retailers to provide the social media link for their store",
              },
            })}
            helper={strictLocalize({
              id: "Zbg91D",
              defaultMessage: "E.g. instagram.com/yourstore",
              description: {
                text: "Explanation text for a form field asking for retailer's social media links",
              },
            })}
          />
        </>
      ) : null}
      <Spacer height="5x" />
      <Button data-test-id="next" disabled={!isNextEnabled} type="submit">
        <StrictLocalMsg
          id="m853T8"
          defaultMessage="Next"
          description={{ text: "Button to visit the next page" }}
        />
      </Button>
    </CommonForm>
  );
};

export const useSchema = () => {
  const { strictLocalize } = useStrictLocalization();

  return Yup.object().shape({
    has_social_media: Yup.bool().required(),
    social_media: Yup.string().when("has_social_media", {
      is: true,
      then: (schema) =>
        schema.required(
          strictLocalize({
            id: "4M2PV3",
            defaultMessage: "Please enter your social media links",
            description: {
              text: "Error message when user hasn't entered this field",
            },
          })
        ),
    }),
  });
};

const SocialMediaContainer = styled(Flex)`
  &&& {
    display: grid;
  }
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  grid-gap: ${getSpacing(12)};

  ${responsiveMediaQueries.tabletAndAbove} {
    flex-wrap: wrap;
    justify-content: space-between;
    gap: ${getSpacing("2x")};
  }
  ${SignUpPillContainer} {
    width: 100%;
  }
`;
